import chroma from "chroma-js";

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  /*container: (styles, { isDisabled, isFocused, isSelected }) => {
    const color = chroma("#000");
    return {
      ...styles,
      backgroundColor: "white",
      color: "#000",
      cursor: isDisabled ? "not-allowed" : "default",
      boxShadow: isFocused || isSelected ? "0 0 0 0.2rem rgb(0 0 0 / 25%)" : "",

      ":active": {
        ...styles[":active"],
        backgroundColor:
          !isDisabled && (isSelected ? color : color.alpha(0.3).css())
      }
    };
  },*/
  control: (styles, { isFocused }) => ({
    ...styles,
    backgroundColor: "white",
    borderColor: "transparent",
    borderWidth: 2,
    borderRadius: 8,
    boxShadow: "none",
    background: "linear-gradient(white, white) padding-box, linear-gradient(176deg, #8A38F5 0%, #00A1A8 100.97%) border-box",
    outline: isFocused ? "2px solid #8A38F5" : "none",
    outlineOffset: 2,

    ":active": {
      borderColor: "transparent",
      boxShadow: isFocused ? "none" : "0 0 0.1rem 0.1rem #8A38F566"
    },
    ":hover": {
      borderColor: "transparent",
      boxShadow: isFocused ? "none" : "0 0 0.1rem 0.1rem #8A38F566"
    }
   }),
  option: (styles, { isDisabled, isFocused, isSelected }) => {
    const color = chroma("#8A38F5");
    return {
      ...styles,
      backgroundColor: isDisabled
        ? null
        : isSelected
        ? color.alpha(0.3).css()
        : isFocused
        ? color.alpha(0.1).css()
        : null,
      color: isDisabled ? "#ccc" : "#282828",
      cursor: isDisabled ? "not-allowed" : "default",
      fontSize: "inherit",

      ":active": {
        ...styles[":active"],
        backgroundColor:
          !isDisabled && (isSelected ? color : color.alpha(0.3).css())
      }
    };
  },
  multiValue: (styles, { data }) => {
    const color = chroma("#44596c");
    return {
      ...styles,
      backgroundColor: color.alpha(0.1).css()
    };
  },
  multiValueLabel: (styles, { data }) => ({
    ...styles,
    color: "#44596c"
  }),
  multiValueRemove: (styles, { data }) => ({
    ...styles,
    color: "#44596c",
    ":hover": {
      backgroundColor: "#44596c",
      color: "white"
    }
  }),
  /*singleValue: (styles, { data, isFocused, isSelected }) => {
    return {
      ...styles,
      boxShadow: isFocused || isSelected ? "0 0 0 0.2rem rgb(0 0 0 / 25%)" : ""
    };
  },*/
};
